<template>
    <install-instructions 
        v-if="!polling" 
        :imei="imei"
        @next="start_polling"
    />
</template>

<script>

    import InstallInstructions from './InstallInstructions'

    export default {

        name: 'VerifyDevice',
        components:{ 
            InstallInstructions,
        },

        props: {
            userData:{ type: Object, required: true },
            imei: { type: String }
        },

        data(){
            return {
                polling: false
            }
        },

        async created(){},

        methods:{
            start_polling(){ this.polling = true },
            stop_polling(){ this.polling = false }
        }
    }

</script>

<style/>
